import React, { useState } from "react";
import { Card, CardHeader, CardBody, Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import BranchEditModal from "./BranchEditmodal";
import AddBranchModal from "./AddbranchModal";

/**
 * Displays the branches array as-is — no pagination, no search.
 * Each row has an Action column with an edit icon that opens BranchEditModal.
 * Header has an "Add More Branch" button that opens AddBranchModal.
 * Pass readOnly to hide both the Action column and the Add More Branch button.
 *
 * Props:
 * - branches: array of branch objects
 * - companyUid: string - passed through to modals for the API calls
 * - onSaved: () => void - called after add/edit succeeds (e.g. refetch company)
 * - readOnly: boolean - hides Action column + Add More Branch button
 */
const BranchesTable = ({ branches = [], companyUid, onSaved, readOnly }) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [isAddOpen, setIsAddOpen] = useState(false);

  const openEdit = (branch) => {
    console.log("Opening edit modal for branch:", branch);
    setSelectedBranch(branch);
    setIsEditOpen(true);
  };

  const columns = [
    {
      dataField: "branch_name",
      text: "Branch Name",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "branch_address",
      text: "Address",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "branch_state",
      text: "State",
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "branch_gst_no",
      text: "GST Number",
      formatter: (cell) => cell || "-",
    },
    ...(!readOnly
      ? [
          {
            dataField: "action",
            text: "Action",
            align: "right",
            headerAlign: "right",
            formatter: (cell, row) => (
              <Button color="link" className="p-0" onClick={() => openEdit(row)}>
                <i className="mdi mdi-pencil font-size-18" />
              </Button>
            ),
          },
        ]
      : []),
  ];

  return (
    <Card className="shadow-sm border-0 mt-4">
      <CardHeader className="bg-white d-flex align-items-center justify-content-between border-bottom py-3">
        <h5 className="mb-0">Branch Details</h5>
        {!readOnly && (
          <Button color="primary" size="sm" onClick={() => setIsAddOpen(true)}>
            <i className="mdi mdi-plus me-1" />
            Add More Branch
          </Button>
        )}
      </CardHeader>
      <CardBody>
        <div className="table-responsive">
          <BootstrapTable
            keyField="_id"
            columns={columns}
            data={branches}
            classes="table align-middle table-nowrap table-hover"
            bordered={false}
            striped={false}
            responsive
            noDataIndication={() => "No branches found"}
          />
        </div>
      </CardBody>

      {!readOnly && (
        <>
          <BranchEditModal
            isOpen={isEditOpen}
            toggle={() => setIsEditOpen(false)}
            companyUid={companyUid}
            branch={selectedBranch}
            onSaved={onSaved}
          />

          <AddBranchModal
            isOpen={isAddOpen}
            toggle={() => setIsAddOpen(false)}
            companyUid={companyUid}
            onSaved={onSaved}
          />
        </>
      )}
    </Card>
  );
};

export default BranchesTable;